import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { niagaraFallsConfig } from "./data";

export default function NiagaraFallsPage() {
  return <CityPageTemplate config={niagaraFallsConfig} />;
}